import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { IAuthenticationResult, IUser } from '../services';

@Injectable({
  providedIn: 'root',
})
export class MockAuthService {
  private _user: IUser = {} as IUser;

  public isAuthenticated(): Observable<boolean> {
    return this.getUser().pipe(map((u: IUser) => !!u));
  }

  public getUser(): Observable<IUser> {
    return of(this._user);
  }

  public setUser(user: IUser): Observable<IUser> {
    return of(this._user);
  }

  readonly isLoggedIn = false;

  get user(): IUser {
    return this._user;
  }

  readonly tokenKey = '';

  readonly tokenEndpoint = '';

  public hasRole(role: string): boolean {
    return true;
  }

  public getCanOverrideOnStop(): boolean {
    return false;
  }

  public getAccessToken(): Observable<string> {
    return of('');
  }

  public async signIn(state: any): Promise<IAuthenticationResult> {
    return this.noAction();
  }

  public async completeSignIn(url: string): Promise<IAuthenticationResult> {
    return this.noAction();
  }

  public async signOut(state: any): Promise<IAuthenticationResult> {
    return this.noAction();
  }

  public async completeSignOut(url: string): Promise<IAuthenticationResult> {
    return this.noAction();
  }

  private noAction(): Promise<IAuthenticationResult> {
    return new Promise<IAuthenticationResult>(() => {
      // ignored
    });
  }
}
